<template lang="html">
  <div class="listchat layout-page" :style="stylechat">
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
      <v-col
        cols="2"
        justify="center"
        align="center"
        class="pa-0"
        @click="routePage('/homepage')"
      >
        <v-icon class="fz-30">mdi-chevron-left</v-icon>
      </v-col>
      <v-col
        cols="8"
        justify="center"
        align="center"
        class="pa-0"
      >
        <span class="tab-title">{{$t('LeftSide.friend.addFriend')}}</span>
      </v-col>
      <v-col
        cols="2"
        justify="center"
        align="center"
        class="pa-0"
      >
      </v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider>
    <v-layout row wrap justify-start align-center class="pt-4 pl-5 pr-5 pb-5">
      <v-text-field
        ref="search"
        v-model="search"
        :placeholder="$t('LeftSide.addFiend.searching')"
        prepend-inner-icon="mdi-magnify"
        solo
        dense
        hide-details
        clearable
        @keyup.enter="searchFriend(search)"
      ></v-text-field>
    </v-layout>
    <div class="layout-listchat mt-5" v-if="status_search === 'start'">
      <v-layout align-center justify-center column class="ma-4">
        <img :src="`${publicPath}/assets/img/onechat/search.jpg`" style="width: 170px;">
        <p class="span-color">{{$t('LeftSide.addFiend.detailSearch')}}</p>
      </v-layout>
    </div>
    <div class="layout-listchat mt-5" v-if="status_search === 'not found'">
      <v-layout align-center justify-center column class="ma-4">
        <img :src="`${publicPath}/assets/img/onechat/nosearch.png`" style="width: 120px; margin-bottom: 20px;">
        <p class="span-color">{{$t('LeftSide.addFiend.nodata', {key: search})}}</p>
      </v-layout>
    </div>
    <div class="layout-listchat" v-if="status_search === 'end'">
      <!-- list user -->
      <v-list flat two-line v-if="listuser.length !== 0">
        <v-subheader>User</v-subheader>
        <template v-for="(item, index) in listuser">
          <v-list-item
            :key="item.tokenroom"
          >
            <v-list-item-avatar>
              <v-img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="img-position"></v-img>
              <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.user.name" class="text-overflow">
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="pb-2">
              <v-btn class="btn-color" text v-if="item.relation === 'friend'" @click="chatRoom(item)">{{$t('AnswerQuestion.chat')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="(item.relation === 'unknown' || item.relation === 'unfriend') && item.collab_mail == 'true'" @click="addFriendCollap(item, index)">{{$t('AnswerQuestion.chat')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="(item.relation === 'unknown' || item.relation === 'unfriend') && item.collab_mail == 'false'" @click="addFriendCollap(item, index)">{{$t('AnswerQuestion.addFriend')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'self'">{{$t('AnswerQuestion.ok')}}</v-btn>
              <v-btn class="btn-color-block" text v-else-if="item.relation === 'block'" @click="unBlock(item, index)">{{$t('AnswerQuestion.unblock')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'request'" @click="acceptFriend(item, index)">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'sendrequest'" @click="cancelRequest(item, index)">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index < listuser.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
      <!-- list bot -->
      <v-list flat two-line v-if="listbot.length !== 0">
        <v-subheader>Bot</v-subheader>
        <template v-for="(item, index) in listbot">
          <v-list-item
            :key="item.tokenroom"
          >
            <v-list-item-avatar>
              <v-img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="img-position"></v-img>
              <img v-else :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.user.name" class="text-overflow">
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="pb-2">
              <v-btn class="btn-color" text v-if="item.relation === 'friend'" @click="chatRoom(item)">{{$t('AnswerQuestion.chat')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'unknown' || item.relation === 'unfriend'" @click="addFriend(item, index)">{{$t('AnswerQuestion.addFriend')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'self'">{{$t('AnswerQuestion.ok')}}</v-btn>
              <v-btn class="btn-color-block" text v-else-if="item.relation === 'block'" @click="unBlock(item, index)">{{$t('AnswerQuestion.unblock')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'request'" @click="acceptFriend(item, index)">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
              <v-btn class="btn-color" text v-else-if="item.relation === 'sendrequest'" @click="cancelRequest(item, index)">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index < listbot.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </div>
    <PasswordBot :PasswordBotDialog="PasswordBotDialog" :PasswordBotDetail="PasswordBotDetail" @closeDialog="closeDialog"/>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Momenttime } from '@/services'
import PasswordBot from '@/components/PasswordBot'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
var VuePullRefresh = require('vue-pull-refresh')
export default {
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      status_search: 'start',
      config: {
        errorLabel: '',
        startLabel: '',
        readyLabel: '',
        loadingLabel: '',
        pullDownHeight: 20
      },
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      PasswordBotDialog: false,
      PasswordBotDetail: {},
      search: '',
      stylechat: {
        "--Addfriend-HeaderColor": "white",
        "--Addfriend-TabBackground": "white",
        "--Addfriend-Icon": "gray",
        "--Addfriend-IconActive": "#2662ae",
        "--Addfriend-Background": "white",
        "--Addfriend-FontSize": "18px",
        "--Addfriend-FontColor": "back",
        "--Addfriend-FontSize-Status": "16px",
        "--Addfriend-FontColor-Status": "grey",
        "--Addfriend-Background-Input": "#E2E1E3",
        "--Addfriend-Color-Button": "#EFF2FE",
        "--Addfriend-FontColor-Button": "#2662ae",
        "--Addfriend-FontColor-Block-Button": "#cb1002"
      },
      listbot: [],
      listuser: [],
      progress: false,
      tokenuser: '',
      data_user: {},
      loading: false
    }
  },
  components: {
    'vue-pull-refresh': VuePullRefresh,
    PasswordBot,
    Warning,
    ErrorAlert
  },
  watch: {
    search () {
      // console.log(this.search)
      if (this.search === '' || this.search === null) {
        this.status_search = 'start'
      }
    }
  },
  computed: {
    ...sync('*')
  },
  created() {
    // console.log(this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    addFriendCollap (item, index) {
      // console.log(`addfriend collap: ${index}`, item)
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend-accept`, {
        tokenuser: this.data_user.tokenuser,
        tokenfriend: item.user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (item.collab_mail === 'true') {
            this.$router.push(`/chat/${response.data.tokenroom}`)
          } else {
            this.listuser[index].relation = 'friend'
            this.listuser[index].user.tokenroom = response.data.tokenroom
          }
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    addFriend (item, index) {
      // console.log('addfriend: ', item)
      // เช็คบอทที่มีรหัสให้กรอกรหัสก่อนแอด
      if (item.user.type === 'bot' && item.user.is_password !== '0') {
        // open dilog password
        this.PasswordBotDetail = item
        this.PasswordBotDialog = true
      } else {
        // add friend
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend`, {
          tokenfriend: item.user.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          // console.log(this.listbot[index])
          if (response.data.status === 'success') {
            if (item.user.type === 'bot') {
              this.listbot[index].relation = 'friend'
              this.listbot[index].user.tokenroom = response.data.tokenroom
            } else {
              this.listuser[index].relation = 'sendrequest'
              this.listuser[index].user.tokenroom = response.data.tokenroom
            }
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    chatRoom (item) {
      // console.log(item);
      this.$router.push(`/chat/${item.user.tokenroom}`)
    },
    unBlock (item, index) {
      // console.log(`unblock: ${index}`, item)
      this.WarningDialogDetail = {
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking',{name: item.user.name}),
        detail: item,
        index: index
      }
      this.WarningDialog = true
    },
    acceptFriend (item, index) {
      // console.log(`accept: ${index}`, item)
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-friend`, {
        tokenfriend: item.user.tokenuser,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.listuser[index].relation = 'friend'
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    cancelRequest (item, index) {
      // console.log(`cancel: ${index}`, item)
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/removerequestfriend`, {
        tokenfriend: item.user.tokenuser,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.listuser[index].relation = 'unknown'
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).then(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    searchFriend (key) {
      // console.log(key)
      if (key !== '' && key !== null) {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchusernontype3`, {
          key: key,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            // console.log(response.data)
            if (response.data['listuser'].length !== 0 || response.data['listBot'].length !== 0) {
              this.status_search = 'end'
            } else {
              this.status_search = 'not found'
            }
            // console.log(this.status_search)
            this.listuser = response.data.listuser
            this.listbot = response.data.listBot
          } else {
            this.progress = false
            this.status_search = 'start'
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          this.status_search = 'start'
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
        tokenuser: this.data_user.tokenuser,
        tokenfriend: item.detail.user.tokenuser,
        tokenroom: item.detail.user.tokenroom
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (item.detail.user.type === 'bot') {
            this.listbot[item.index].relation = 'friend'
            this.listbot[item.index].user.tokenroom = item.detail.user.tokenroom
          } else {
            this.listuser[item.index].relation = 'friend'
            this.listuser[item.index].user.tokenroom = item.detail.user.tokenroom
          }
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    closeDialog () {
      this.PasswordBotDialog = false
    },
    openMenu () {
      this.PasswordBotDialog = true
    },
    routePage (path) {
      this.$router.push(path)
    },
    time (timestamp) {
      if (this.$i18n.locale == 'th') {
        return Momenttime.dayjstimethaiformnow(timestamp)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.dayjstimethaiformnowcn(timestamp)
      } else {
        return Momenttime.dayjstimethaiformnowen(timestamp)
      }
      // return Momenttime.dayjstimethaiformnow(timestamp)
    },
  }
}
</script>

<style lang="css" scoped>
.btn-color {
  color: var(--Addfriend-FontColor-Button) !important;
  text-transform: none !important;
  border-radius: 10px !important;
  min-width: 125px !important;
}
.btn-color-block {
  color: var(--Addfriend-FontColor-Block-Button) !important;
  text-transform: none !important;
  border-radius: 10px !important;
  min-width: 125px !important;
}
.icon-color {
  color: var(--Addfriend-IconActive) !important;
}
.fz-18 {
  font-size: 18px !important;
}
.fz-20 {
  font-size: 20px !important;
}
.fz-30 {
  font-size: 30px !important;
}
.layout-listchat {
  height: calc(100vh - 106px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-listchat::-webkit-scrollbar {
  width: 4px;
}

.layout-listchat::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
>>>.pull-down-container {
  /* padding: 0px !important; */
  /* overflow-y: hidden !important; */
  height: unset !important;
  max-height: unset !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
>>>.pull-down-container::-webkit-scrollbar {
  height: 10px;
  width: 0px;
}
>>>.pull-down-header {
  width: 100%;
  height: 0px;
  overflow: hidden;
  position: relative;
  background-color: var(--Addfriend-Background) !important;
}
>>>.pull-down-content {
  position: absolute;
  max-width: 90%;
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  height: 40px;
  color: #0054ad;
  text-align: center;
  border-left: 20px solid transparent;
  font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}
.tab-title {
  color: var(--Addfriend-FontColor) !important;
  font-size: var(--Addfriend-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Addfriend-FontColor-Status) !important;
  font-size: var(--Addfriend-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
>>>.v-input__slot {
  background-color: var(--Addfriend-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.tab-title {
  color: var(--Addfriend-FontColor) !important;
  font-size: var(--Addfriend-FontSize) !important;
  font-weight: 600;
}
.span-color {
  color: var(--Addfriend-FontColor) !important;
  font-size: var(--Addfriend-FontSize) !important;
}
.layout-page {
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--Addfriend-Background) !important;
}
</style>
